<section class="pricing-page">

  <div
    class="pricing-success"
    *ngIf="registered"
  >
    <div class="pricing-success__icon">
      ✓
    </div>

    <div>
      <strong>
        {{ 'PRICING.REGISTRATION_SUCCESS_TITLE' | translate }}
      </strong>

      <p>
        {{ 'PRICING.REGISTRATION_SUCCESS_TEXT' | translate }}
      </p>
    </div>
  </div>

  <header class="pricing-header">
    <span class="pricing-header__badge">
      {{ 'PRICING.BADGE' | translate }}
    </span>

    <h1>
      {{ 'PRICING.TITLE' | translate }}
    </h1>

    <p>
      {{ 'PRICING.SUBTITLE' | translate }}
    </p>

    <div class="pricing-trial-benefits">
      <span>
        ✓ {{ 'PRICING.NO_CARD' | translate }}
      </span>

      <span>
        ✓ {{ 'PRICING.FULL_ACCESS' | translate }}
      </span>

      <span>
        ✓ {{ 'PRICING.CANCEL_ANYTIME' | translate }}
      </span>
    </div>
  </header>

  <div class="pricing-grid">

    <article
      class="pricing-card"
      *ngFor="let plan of plans"
      [class.pricing-card--selected]="
        selectedPlan?.key === plan.key
      "
      [class.pricing-card--recommended]="
        plan.recommended
      "
      (click)="selectPlan(plan)"
    >

      <div
        class="pricing-card__recommended"
        *ngIf="plan.recommended"
      >
        {{ 'PRICING.RECOMMENDED' | translate }}
      </div>

      <div class="pricing-card__top">
        <h2>
          {{ plan.nameKey | translate }}
        </h2>

        <p>
          {{ plan.descriptionKey | translate }}
        </p>
      </div>

      <div class="pricing-card__price">
        <span class="pricing-card__currency">
          €
        </span>

        <strong>
          {{ plan.price }}
        </strong>

        <span class="pricing-card__period">
          / {{ 'PRICING.MONTH' | translate }}
        </span>
      </div>

      <div class="pricing-card__trial">
        {{ 'PRICING.TRIAL_TEXT' | translate }}
      </div>

      <ul class="pricing-card__features">
        <li
          *ngFor="let featureKey of plan.featureKeys"
        >
          <span>✓</span>

          {{ featureKey | translate }}
        </li>
      </ul>

      <button
        type="button"
        class="pricing-card__button"
        (click)="selectPlan(plan); $event.stopPropagation()"
      >
        {{
          selectedPlan?.key === plan.key
            ? ('PRICING.SELECTED' | translate)
            : ('PRICING.SELECT' | translate)
        }}
      </button>

    </article>

  </div>

  <div class="pricing-footer">

    <div>
      <span>
        {{ 'PRICING.SELECTED_PLAN' | translate }}
      </span>

      <strong *ngIf="selectedPlan">
        {{ selectedPlan.nameKey | translate }}
      </strong>
    </div>

    <button
      type="button"
      class="pricing-footer__button"
      [disabled]="!selectedPlan"
      (click)="continueToDashboard()"
    >
      {{ 'PRICING.CONTINUE' | translate }}

      <span>→</span>
    </button>

  </div>

</section>